import ReactApexChart from "react-apexcharts";

const Chart =
  typeof ReactApexChart === "function"
    ? ReactApexChart
    : ReactApexChart?.default;

if (typeof Chart !== "function") {
  throw new Error("react-apexcharts did not export a React component");
}

Chart.displayName = Chart.displayName || "ApexChart";

export default Chart;
